import * as React from 'react';

interface Props {
  step: string;
}

interface Step {
  key: string;
  className: string;
  action: string;
  concept: string;
  activeColor: string;
}

const ProjectFormalizationHeaderComponent: React.StatelessComponent<Props> = (props: Props) => {
  let steps: Step[] = [
    {
      key: 'Reviewing Profile',
      className: 'step step-1',
      action: 'Confirmar',
      concept: 'datos',
      activeColor: 'c-orange-dark',
    },
    {
      key: 'Confirmed Profile',
      className: 'step step-4',
      action: 'Confirmar',
      concept: 'importe',
      activeColor: 'c-orange-dark',
    },
    {
      key: 'Confirmed Amount',
      className: 'step step-6',
      action: 'Redactando',
      concept: 'contratos',
      activeColor: 'attention',

    },
    {
      key: 'Reviewing Contracts',
      className: 'step step-7',
      action: 'Revisar',
      concept: 'contratos',
      activeColor: 'c-orange-dark',
    },
    {
      key: 'Accepted Contracts',
      className: 'step step-8',
      action: 'Firmar',
      concept: 'contratos',
      activeColor: 'c-orange-dark',
    },
  ];

  let found = false;
  return (
    <div className="stepper stepper-big">
      {
        steps.map((step => {

          if (props.step.startsWith(step.key)) {
            found = true;
            return (
              <div
                key={step.key}
                className={step.className + ' validation'}
              >
                <p className={'f-s-12 hidden-xs ' + step.activeColor}>
                  {step.action}<br />{step.concept}<br />
                  <span className={step.activeColor === 'atention' ? 'alert-yellow-med' : 'close-orange-med'} />
                </p>
              </div>
            );
          }

          return (
            <div
              key={step.key}
              className={step.className + (found ? '' : ' active')}
            >
              <p className="f-s-12 hidden-xs">
                {step.action}<br />{step.concept}<br />
                <span className={found ? 'line-grey-med' : 'corrected-med'} />
              </p>
            </div>
          );
        }))
      }
      <div className="line" />
    </div>
  );
};

export default ProjectFormalizationHeaderComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/project-formalization/partials/ProjectFormalizationHeader.component.tsx